import { useEffect, useState } from 'react';
import { post } from '../Auths/AuthToken';
import { Link, useNavigate, useParams } from 'react-router-dom';
import TreatPlanNoteEdit from './TreatPlanNoteEdit';
import GoalPlanViewPopup from './GoalPlanViewPopup';
import { DEFAULT_LOCAL_PATH } from '../../constents';
import { useSelector } from 'react-redux';
import setUiMessage from '../../Utilities/Tostify';

function PatientTreatmentPlan({ patientId }) {
  const { user } = useSelector((state) => state.auth);
  const { globalReload } = useSelector((state) => state.auth);
  const [allData, setAllData] = useState(null);
  const [dateAdded, setDateAddedSerch] = useState('');
  const [reviewDate, setReviewDateSerch] = useState('');
  const [provId, setProvIdSerch] = useState('');
  const [provSignSt, setProvStSerch] = useState('');
  const [superVisor, setSuperVisorSerch] = useState('');
  const [superVisorSignSt, setSuperVisorSignStSerch] = useState('');
  const [patSignSt, setPatSignStSerch] = useState('');
  const [actionSt, setActionStSerch] = useState('');
  const [serviceCode, setServiceCodeSerch] = useState('');
  const [billSt, setBillStSerch] = useState('');
  const [goalPlanViewPopup, setGoalPlanViewPopup] = useState(false);
  const [appointmentId, setAppointmentId] = useState(false);
  const [visitId, setVisitId] = useState(false);
  const [treatmentId, setTreatmentId] = useState(false);
  const [reviewed, seTreviewed] = useState(false);
  const [status, setStatus] = useState(0);
  const [planType, setPlanType] = useState(0);
  const navigate = useNavigate();
  const { appId } = useParams();
  const [reload, setReload] = useState(false);
  function handleReload() {
    setReload(!reload);
  }
  useEffect(() => {
    (async () => {
      try {
        const response = await post(
          'api/patient/TreatmentPlan/treatmentPlanList',
          {
            patientId: patientId,
            dateAdded: dateAdded,
            reviewDate: reviewDate,
            provId: provId,
            provSignSt: provSignSt,
            superVisor: superVisor,
            superVisorSignSt: superVisorSignSt,
            patSignSt: patSignSt,
            actionSt: actionSt,
            serviceCode: serviceCode,
            billSt: billSt,
            staffUserId: user?.id,
          },
        );
        if (response.status === 200) {
          setAllData(response?.data);
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  }, [
    patientId,
    dateAdded,
    reviewDate,
    provId,
    provSignSt,
    superVisor,
    superVisorSignSt,
    patSignSt,
    actionSt,
    serviceCode,
    billSt,
    globalReload,
    user?.id,
    reload,
  ]);

  const handleViewTemplate = async (
    appId,
    visitId,
    treatId,
    reviewed,
    status,
    type,
  ) => {
    if (type === '3') {
      if (status === '1') {
        navigate(
          `${DEFAULT_LOCAL_PATH}/patient/treatPlan/${patientId}/${appId}/${visitId}/${treatId}`,
        );
      } else {
        setGoalPlanViewPopup(true);
        setAppointmentId(appId);
        setVisitId(visitId);
        setTreatmentId(treatId);
        seTreviewed(reviewed);
        setStatus(status);
        setPlanType(type);
      }
    }
  };

  return (() => {
    if (appId) {
      return (
        <TreatPlanNoteEdit
          patientId={patientId}
          appId={appId}
          handleReloadCf={handleReload}
        />
      );
    } else if (appId === undefined) {
      return (
        <div className="c-mid-bdy-blk">
          <div className="t-plan-hdr">
            <span className="t-plan-lbl pc-col-1 hide">
              <span className="bold">Chart#</span>
              <input
                type="search"
                className="main-search"
                placeholder="Search Chart#..."
              />
            </span>
            <span className="t-plan-lbl pc-col-3 hide">
              <span className="bold">Patient</span>
              <input
                type="search"
                className="main-search"
                placeholder="Search Patient..."
              />
            </span>
            <span className="t-plan-lbl pc-col-2">
              <span className="bold">Added</span>
              <input
                type="search"
                className="main-search"
                placeholder="Search date..."
                value={dateAdded}
                onChange={(e) => setDateAddedSerch(e.target.value)}
              />
            </span>
            <span className="t-plan-lbl pc-col-2">
              <span className="bold">Review</span>
              <input
                type="search"
                className="main-search"
                placeholder="Search date..."
                value={reviewDate}
                onChange={(e) => setReviewDateSerch(e.target.value)}
              />
            </span>
            <span className="t-plan-lbl pc-col-1">
              <span className="bold">Clinician</span>
              <select
                className="appt-col-slct"
                value={provId}
                onChange={(e) => setProvIdSerch(e.target.value)}
              >
                <option value="">All</option>
                {allData?.allResource &&
                  allData?.allResource.map((note, idx) => {
                    return (
                      <option key={idx} value={note?.id}>
                        {note?.resName}
                      </option>
                    );
                  })}
              </select>
            </span>
            <span className="t-plan-lbl pc-col-4">
              <span className="bold">Clinician Sign.</span>
              <select
                className="appt-col-slct"
                value={provSignSt}
                onChange={(e) => setProvStSerch(e.target.value)}
              >
                <option value="">All</option>
                {allData?.signStatus &&
                  allData?.signStatus.map((note, idx) => {
                    return (
                      <option key={idx} value={note?.id}>
                        {note?.val}
                      </option>
                    );
                  })}
              </select>
            </span>
            <span className="t-plan-lbl pc-col-1">
              <span className="bold">Supervisor</span>
              <select
                className="appt-col-slct"
                value={superVisor}
                onChange={(e) => setSuperVisorSerch(e.target.value)}
              >
                <option value="">All</option>
                {allData?.allResource &&
                  allData?.allResource.map((note, idx) => {
                    return (
                      <option key={idx} value={note?.id}>
                        {note?.resName}
                      </option>
                    );
                  })}
              </select>
            </span>
            <span className="t-plan-lbl pc-col-4">
              <span className="bold">Supervisor Sign.</span>
              <select
                className="appt-col-slct"
                value={superVisorSignSt}
                onChange={(e) => setSuperVisorSignStSerch(e.target.value)}
              >
                <option value="">All</option>
                {allData?.signStatus &&
                  allData?.signStatus.map((note, idx) => {
                    return (
                      <option key={idx} value={note?.id}>
                        {note?.val}
                      </option>
                    );
                  })}
              </select>
            </span>
            <span className="t-plan-lbl pc-col-4">
              <span className="bold">Patient Sign.</span>
              <select
                className="appt-col-slct"
                value={patSignSt}
                onChange={(e) => setPatSignStSerch(e.target.value)}
              >
                <option value="">All</option>
                {allData?.signStatus &&
                  allData?.signStatus.map((note, idx) => {
                    return (
                      <option key={idx} value={note?.id}>
                        {note?.val}
                      </option>
                    );
                  })}
              </select>
            </span>
            <span className="t-plan-lbl pc-col-1">
              <span className="bold">Action</span>
              <select
                className="appt-col-slct"
                value={actionSt}
                onChange={(e) => setActionStSerch(e.target.value)}
              >
                <option value="">All</option>
                {allData?.actionFilter &&
                  allData?.actionFilter.map((filter, idx) => {
                    return (
                      <option key={idx} value={filter?.id}>
                        {filter?.val}
                      </option>
                    );
                  })}
              </select>
            </span>
            <span className="t-plan-lbl pc-col-1">
              <span className="bold">Payor</span>
              <select className="appt-col-slct">
                <option value="">All Payor</option>
                {allData?.allInsurance &&
                  allData?.allInsurance.map((ins, idx) => {
                    return (
                      <option key={idx} value={ins?.id}>
                        {ins?.insName}
                      </option>
                    );
                  })}
              </select>
            </span>
            <span className="t-plan-lbl pc-col-1">
              <span className="bold">Service Code</span>
              <input
                type="search"
                className="main-search"
                placeholder="Search Service Code..."
                value={serviceCode}
                onChange={(e) => setServiceCodeSerch(e.target.value)}
              />
            </span>
            <span className="t-plan-lbl pc-col-2 bold">Dx</span>

            <span className="t-plan-lbl pc-col-1">
              <span className="bold">Billing</span>
              <select
                className="appt-col-slct"
                value={billSt}
                onChange={(e) => setBillStSerch(e.target.value)}
              >
                <option value="">All</option>
                {allData?.billStatus &&
                  allData?.billStatus.map((bill, idx) => {
                    return (
                      <option key={idx} value={bill?.id}>
                        {bill?.val}
                      </option>
                    );
                  })}
              </select>
            </span>
            <span className="t-plan-lbl pc-col-2 bold">$</span>
          </div>
          {allData?.tretPlan && allData.tretPlan.length > 0 ? (
            <div className="t-plan-bdy">
              {allData?.tretPlan &&
                allData?.tretPlan.map((plan, idx) => {
                  const ltClass = idx % 2 === 0 ? '' : 'alt-rw';
                  return (
                    <div key={idx} className={`t-plan-bdy-rw ${ltClass}`}>
                      <span className="t-plan-lbl pc-col-2">
                        {plan?.addedDt}
                      </span>
                      <span className="t-plan-lbl pc-col-2">
                        {plan?.reviewDt}
                      </span>
                      <span className="t-plan-lbl pc-col-1">
                        {plan?.clinician}
                      </span>
                      <span className="t-plan-lbl pc-col-4 maroon">
                        {plan?.clinicianSignSt}
                      </span>
                      <span className="t-plan-lbl pc-col-1">
                        {plan?.supervisor}
                      </span>
                      <span className="t-plan-lbl pc-col-4 maroon ">
                        {plan?.supervisorSignSt}
                      </span>
                      <span className="t-plan-lbl pc-col-4 maroon">
                        {plan?.patSign}
                      </span>
                      <span className="t-plan-lbl pc-col-1">
                        <span
                          className=""
                          onClick={() =>
                            handleViewTemplate(
                              plan?.appId,
                              plan?.visitId,
                              plan?.treatId,
                              plan?.reviewed,
                              plan?.status,
                              plan?.type,
                            )
                          }
                        >
                          <Link to=""> {plan?.actionLabel}</Link>
                        </span>
                      </span>
                      <span className="t-plan-lbl pc-col-1">{plan?.payor}</span>
                      <span className="t-plan-lbl pc-col-1">
                        {plan?.procName}
                      </span>
                      <span className="t-plan-lbl pc-col-2">{plan?.dx}</span>
                      <span className="t-plan-lbl pc-col-1">
                        {plan?.billingSt}
                      </span>
                      <span className="t-plan-lbl pc-col-2">{plan?.amt}</span>
                    </div>
                  );
                })}
            </div>
          ) : (
            <p className="no-appoinmnts-here">No Pt. Information !!</p>
          )}
          {goalPlanViewPopup && (
            <GoalPlanViewPopup
              close={() => setGoalPlanViewPopup(false)}
              patientId={patientId}
              appointmentId={appointmentId}
              visitId={visitId}
              treatId={treatmentId}
              reviewed={reviewed}
              status={status}
              type={planType}
              handleTreatPlanListReload={handleReload}
            />
          )}
        </div>
      );
    }
  })();
}

export default PatientTreatmentPlan;
